import React from 'react';
import { Navigate } from 'react-router-dom';
import './styles/index.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Main from './pages/Main/Main';
import ACETrader from './pages/Sub/Solutions/ACETrader';
import Exchange from './pages/Sub/Solutions/Exchange';
import Adlib from './pages/Sub/Solutions/Adlib';
import Notice from './pages/Sub/Resources/Notice';
import NoticeDetail from './pages/Sub/Resources/NoticeDetail';
import Faq from './pages/Sub/Resources/Faq';
import Data from './pages/Sub/Resources/Data';
import Blog from './pages/Sub/Resources/Blog';
import BlogDetail from './pages/Sub/Resources/BlogDetail';
import About from './pages/Sub/Company/About';
import Location from './pages/Sub/Company/Location';
import Terms from './pages/Terms/Terms';
import Privacy from './pages/Terms/Privacy';
import CustomizedAd from './pages/Terms/CustomizedAd';

import { LanguageProvider } from './hooks/useLanguage';

function App() {
  console.log("Front-end Developer : 권준형, Back-end Developer : 전유민, 최재환, Publishing Developer : 고민채")

  return (
    <LanguageProvider>
      <div id="App" className="App">
        <Router>
          <ScrollToTop /> 
          <Header />
          <Routes>
            <Route path="/" element={<Main />} />

            {/* 서브페이지 */}
            {/* solutions */}
            <Route path="/solutions/aceTrader" element={<ACETrader />} />
            <Route path="/solutions/aceExchange" element={<Exchange />} />
            <Route path="/solutions/adlib" element={<Adlib />} />
            {/* resources */}
            <Route path="/resources/notice" element={<Notice />} />
            <Route path="/resources/notice/noticeDetail/:b_seq" element={<NoticeDetail />} />
            <Route path="/resources/faq" element={<Faq />} />
            <Route path="/resources/data" element={<Data />} />
            <Route path="/resources/blog" element={<Blog />} />
            <Route path="/resources/blog/blogDetail/:b_seq" element={<BlogDetail />} />
            {/* Company */}
            <Route path="/company/about" element={<About/>}/>
            <Route path="/company/location" element={<Location/>}/>

            {/* Terms */}
            <Route path="/terms" element={<Navigate to="/terms/acetrader" replace />} />
            <Route path="/terms/:type" element={<Terms />} />
            <Route path="/privacy" element={<Navigate to="/privacy/acetrader" replace />} />
            <Route path="/privacy/:type" element={<Privacy />} />
            <Route path="/customizedAd" element={<Navigate to="/customizedAd/acetrader" replace />} />
            <Route path="/customizedAd/:type" element={<CustomizedAd />} />
            
          </Routes>
          <Footer />
        </Router>
      </div>
    </LanguageProvider>
  );
}

export default App;
